// index.ts
import { CRUDL, installExtension } from "@juitnow/lib-fetch-client";
var InventoriesImpl = class {
  _crudl;
  constructor(http) {
    this._crudl = new CRUDL(http, "/inventories/v1");
  }
  async list(query) {
    const path = `/inventories/v1/${query.location_uuid}`;
    const parameters = query.ean?.length ? { ean: query.ean.join(",") } : void 0;
    const response = await this._crudl.http.get(path, { parameters });
    return response.data;
  }
};
installExtension("inventories", InventoriesImpl);
export {
  InventoriesImpl
};
//# sourceMappingURL=index.mjs.map
